// NOTE: GENERATED FILE — do not edit by hand.
//
// Produced by `bun scripts/vendor-integration-logos/vendor-integration-logos.ts`,
// which reads every toolkit's `meta.logo` from Pipedream and mirrors the image
// into `apps/nsai/web/public/integration-logos/`. Re-run the generator and
// commit both sides.
//
// Why mirrored and not fetched at runtime: NSAI ships on-prem, so a client that
// pulled brand logos off a third-party CDN on every render would tell that CDN
// which integrations a customer browses — and would render nothing at all in an
// air-gapped install. Mirroring keeps the logos inside the bundle we ship.

export const VENDORED_INTEGRATION_LOGOS: Readonly<Record<string, string>> = {
  _21risk: "/integration-logos/_21risk.png",
  _2chat: "/integration-logos/_2chat.png",
  ably: "/integration-logos/ably.png",
  abstract: "/integration-logos/abstract.png",
  abuselpdb: "/integration-logos/abuselpdb.png",
  abyssale: "/integration-logos/abyssale.png",
  active_campaign: "/integration-logos/active_campaign.png",
  active_trail: "/integration-logos/active_trail.png",
  addresszen: "/integration-logos/addresszen.png",
  adrapid: "/integration-logos/adrapid.png",
  adyntel: "/integration-logos/adyntel.png",
  aeroleads: "/integration-logos/aeroleads.svg",
  affinda: "/integration-logos/affinda.png",
  affinity: "/integration-logos/affinity.png",
  agentql: "/integration-logos/agentql.png",
  agenty: "/integration-logos/agenty.png",
  agiled: "/integration-logos/agiled.png",
  agility_cms: "/integration-logos/agility_cms.png",
  ahrefs: "/integration-logos/ahrefs.jpg",
  ai_ml_api: "/integration-logos/ai_ml_api.png",
  airtable: "/integration-logos/airtable.png",
  aivoov: "/integration-logos/aivoov.png",
  alchemy: "/integration-logos/alchemy.png",
  algodocs: "/integration-logos/algodocs.png",
  algolia: "/integration-logos/algolia.svg",
  all_images_ai: "/integration-logos/all_images_ai.png",
  alpha_vantage: "/integration-logos/alpha_vantage.png",
  altoviz: "/integration-logos/altoviz.png",
  alttext_ai: "/integration-logos/alttext_ai.png",
  amara: "/integration-logos/amara.png",
  ambee: "/integration-logos/ambee.png",
  ambient_weather: "/integration-logos/ambient_weather.png",
  amcards: "/integration-logos/amcards.png",
  amplitude: "/integration-logos/amplitude.png",
  anchor_browser: "/integration-logos/anchor_browser.png",
  anonyflow: "/integration-logos/anonyflow.png",
  apaleo: "/integration-logos/apaleo.png",
  api_bible: "/integration-logos/api_bible.svg",
  api_labz: "/integration-logos/api_labz.svg",
  api_ninjas: "/integration-logos/api_ninjas.png",
  api_sports: "/integration-logos/api_sports.png",
  api2pdf: "/integration-logos/api2pdf.png",
  apiflash: "/integration-logos/apiflash.png",
  apify: "/integration-logos/apify.svg",
  apilio: "/integration-logos/apilio.png",
  apipie_ai: "/integration-logos/apipie_ai.png",
  apiverve: "/integration-logos/apiverve.png",
  apollo: "/integration-logos/apollo.png",
  appcircle: "/integration-logos/appcircle.png",
  appdrag: "/integration-logos/appdrag.png",
  appointo: "/integration-logos/appointo.png",
  appveyor: "/integration-logos/appveyor.png",
  aryn: "/integration-logos/aryn.png",
  asana: "/integration-logos/asana.png",
  ascora: "/integration-logos/ascora.png",
  ashby: "/integration-logos/ashby.png",
  asin_data_api: "/integration-logos/asin_data_api.png",
  astica_ai: "/integration-logos/astica_ai.png",
  async_interview: "/integration-logos/async_interview.png",
  "atlassian-confluence": "/integration-logos/atlassian-confluence.png",
  "atlassian-confluence-dc": "/integration-logos/atlassian-confluence-dc.png",
  "atlassian-jira": "/integration-logos/atlassian-jira.svg",
  "atlassian-jira-dc": "/integration-logos/atlassian-jira-dc.svg",
  attio: "/integration-logos/attio.png",
  autobound: "/integration-logos/autobound.png",
  autom: "/integration-logos/autom.png",
  ayrshare: "/integration-logos/ayrshare.png",
  "azure-calendar": "/integration-logos/azure-calendar.png",
  "azure-excel": "/integration-logos/azure-excel.png",
  "azure-microsoft-teams": "/integration-logos/azure-microsoft-teams.png",
  "azure-onedrive": "/integration-logos/azure-onedrive.png",
  "azure-outlook": "/integration-logos/azure-outlook.png",
  "azure-share-point": "/integration-logos/azure-share-point.png",
  bamboohr: "/integration-logos/bamboohr.png",
  bannerbear: "/integration-logos/bannerbear.png",
  bart: "/integration-logos/bart.png",
  basecamp: "/integration-logos/basecamp.png",
  baserow: "/integration-logos/baserow.png",
  basin: "/integration-logos/basin.png",
  beaconchain: "/integration-logos/beaconchain.png",
  beaconstac: "/integration-logos/beaconstac.png",
  beeminder: "/integration-logos/beeminder.png",
  benchmark_email: "/integration-logos/benchmark_email.png",
  benzinga: "/integration-logos/benzinga.jpg",
  better_proposals: "/integration-logos/better_proposals.png",
  better_stack: "/integration-logos/better_stack.png",
  bettercontact: "/integration-logos/bettercontact.png",
  bidsketch: "/integration-logos/bidsketch.png",
  big_data_cloud: "/integration-logos/big_data_cloud.png",
  bigmailer: "/integration-logos/bigmailer.png",
  bigml: "/integration-logos/bigml.png",
  bigpicture_io: "/integration-logos/bigpicture_io.png",
  bitbucket: "/integration-logos/bitbucket.png",
  bitquery: "/integration-logos/bitquery.png",
  bitwarden: "/integration-logos/bitwarden.png",
  blazemeter: "/integration-logos/blazemeter.png",
  blocknative: "/integration-logos/blocknative.png",
  boldsign: "/integration-logos/boldsign.png",
  boloforms: "/integration-logos/boloforms.png",
  bolt_iot: "/integration-logos/bolt_iot.png",
  bookingmood: "/integration-logos/bookingmood.png",
  botpress: "/integration-logos/botpress.png",
  bouncer: "/integration-logos/bouncer.png",
  box: "/integration-logos/box.png",
  boxhero: "/integration-logos/boxhero.png",
  brandfetch: "/integration-logos/brandfetch.png",
  breeze: "/integration-logos/breeze.png",
  brevo: "/integration-logos/brevo.png",
  brex: "/integration-logos/brex.png",
  brightdata: "/integration-logos/brightdata.png",
  brilliant_directories: "/integration-logos/brilliant_directories.png",
  browseai: "/integration-logos/browseai.png",
  calendly: "/integration-logos/calendly.png",
  canva: "/integration-logos/canva.png",
  canvas: "/integration-logos/canvas.jpg",
  clickup: "/integration-logos/clickup.png",
  clockify: "/integration-logos/clockify.png",
  contentful: "/integration-logos/contentful.png",
  crowdin: "/integration-logos/crowdin.svg",
  dart: "/integration-logos/dart.png",
  databricks: "/integration-logos/databricks.png",
  datadog: "/integration-logos/datadog.png",
  dialpad: "/integration-logos/dialpad.png",
  digital_ocean: "/integration-logos/digital_ocean.png",
  discord: "/integration-logos/discord.png",
  discordbot: "/integration-logos/discordbot.png",
  docusign: "/integration-logos/docusign.png",
  dropbox: "/integration-logos/dropbox.svg",
  dub: "/integration-logos/dub.png",
  epic_games: "/integration-logos/epic_games.png",
  eventbrite: "/integration-logos/eventbrite.png",
  exist: "/integration-logos/exist.png",
  fathom: "/integration-logos/fathom.png",
  figma: "/integration-logos/figma.png",
  fireflies: "/integration-logos/fireflies.png",
  follow_up_boss: "/integration-logos/follow_up_boss.png",
  freeagent: "/integration-logos/freeagent.png",
  freshbooks: "/integration-logos/freshbooks.svg",
  github: "/integration-logos/github.png",
  gitlab: "/integration-logos/gitlab.png",
  gong: "/integration-logos/gong.png",
  google_analytics: "/integration-logos/google_analytics.png",
  google_classroom: "/integration-logos/google_classroom.png",
  google_search_console: "/integration-logos/google_search_console.png",
  "google-calendar": "/integration-logos/google-calendar.png",
  "google-drive": "/integration-logos/google-drive.png",
  "google-mail": "/integration-logos/google-mail.png",
  "google-meet": "/integration-logos/google-meet.png",
  "google-sheets": "/integration-logos/google-sheets.png",
  googleads: "/integration-logos/googleads.png",
  googledocs: "/integration-logos/googledocs.png",
  googlephotos: "/integration-logos/googlephotos.png",
  googleslides: "/integration-logos/googleslides.png",
  googletasks: "/integration-logos/googletasks.png",
  gumroad: "/integration-logos/gumroad.png",
  harvest: "/integration-logos/harvest.png",
  help_scout: "/integration-logos/help_scout.svg",
  hubspot: "/integration-logos/hubspot.svg",
  hugging_face: "/integration-logos/hugging_face.png",
  insighto_ai: "/integration-logos/insighto_ai.png",
  intercom: "/integration-logos/intercom.svg",
  klaviyo: "/integration-logos/klaviyo.svg",
  lever: "/integration-logos/lever.png",
  linear: "/integration-logos/linear.svg",
  linkedin: "/integration-logos/linkedin.png",
  linkedin_ads: "/integration-logos/linkedin_ads.png",
  lodgify: "/integration-logos/lodgify.png",
  mailchimp: "/integration-logos/mailchimp.png",
  matterport: "/integration-logos/matterport.png",
  "microsoft-bookings": "/integration-logos/microsoft-bookings.png",
  "microsoft-dataverse": "/integration-logos/microsoft-dataverse.png",
  "microsoft-planner": "/integration-logos/microsoft-planner.png",
  "microsoft-power-bi": "/integration-logos/microsoft-power-bi.png",
  "microsoft-todo": "/integration-logos/microsoft-todo.png",
  monday: "/integration-logos/monday.png",
  moneybird: "/integration-logos/moneybird.svg",
  mural: "/integration-logos/mural.png",
  nextcloud: "/integration-logos/nextcloud.png",
  notion: "/integration-logos/notion.svg",
  odoo: "/integration-logos/odoo.png",
  omnisend: "/integration-logos/omnisend.png",
  onenote: "/integration-logos/onenote.png",
  pagerduty: "/integration-logos/pagerduty.svg",
  parma: "/integration-logos/parma.png",
  pinecone: "/integration-logos/pinecone.png",
  pipedrive: "/integration-logos/pipedrive.png",
  "power-automate": "/integration-logos/power-automate.png",
  productboard: "/integration-logos/productboard.png",
  pushbullet: "/integration-logos/pushbullet.png",
  quickbooks: "/integration-logos/quickbooks.png",
  ramp: "/integration-logos/ramp.png",
  reddit: "/integration-logos/reddit.png",
  sentry: "/integration-logos/sentry.png",
  slack: "/integration-logos/slack.png",
  smartsheet: "/integration-logos/smartsheet.png",
  square: "/integration-logos/square.png",
  stack_exchange: "/integration-logos/stack_exchange.png",
  supabase: "/integration-logos/supabase.svg",
  telegram: "/integration-logos/telegram.svg",
  ticktick: "/integration-logos/ticktick.png",
  todoist: "/integration-logos/todoist.png",
  trello: "/integration-logos/trello.png",
  typeform: "/integration-logos/typeform.png",
  wakatime: "/integration-logos/wakatime.svg",
  zendesk: "/integration-logos/zendesk.png",
  "zoho-analytics": "/integration-logos/zoho-analytics.png",
  "zoho-crm": "/integration-logos/zoho-crm.png",
  "zoho-desk": "/integration-logos/zoho-desk.png",
  "zoho-mail": "/integration-logos/zoho-mail.png",
  "zoho-workdrive": "/integration-logos/zoho-workdrive.png",
  zoom: "/integration-logos/zoom.svg",
};
